import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../abstract/api.service';

/** Agremo map actions: `/admin/agremo/maps` (hub `admin-agremo-maps-controller.ts`). */
@Injectable({ providedIn: 'root' })
export class AgremoMapService extends ApiService {
  constructor() {
    super('admin/agremo/maps');
  }

  /** POST /admin/agremo/maps/:id/recheck: re-queues a failed map's readiness check. */
  recheckMap(mapId: string): Observable<void> {
    return this.request('POST', { id: mapId, path: 'recheck' }, () => undefined, {});
  }
}
